import { motion, useReducedMotion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 28,
    mass: 0.4,
  });

  if (reduced) return null;

  return (
    <motion.div
      aria-hidden="true"
      role="presentation"
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-accent origin-left z-[60] pointer-events-none"
    />
  );
};
